import {
  IonButton,
  IonCol,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonRadio,
  IonRadioGroup,
  IonRow,
  IonTitle,
} from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import { IPregunta } from "../../entities/IPregunta";
import Axios from "axios";
import config from "../../config.json";
import { shuffle } from "../../svc/Helper";
import errorHandler from "../../svc/ErrorHandler";
import "./style.css";
import { Loading } from "../../components/Loading";

export const Questions = (props: { onFinish: (result: string[]) => void }) => {
  const [data, setData] = useState<IPregunta[]>([]);
  let result = useRef<(string | undefined)[]>([]);
  let stateTest = useRef<"none" | "init" | "basic" | "discriminator">("none");
  let index = useRef<number>(0);

  let [errors, setErrors] = useState<string[]>([]);
  let [modal, setModal] = useState<boolean>(false);

  useEffect(() => {
    if (!data.length) {
      Axios.get<IPregunta[]>(config.api.cuestionario)
        .then((x) => {
          if (x.status >= 200 && x.status < 400) {
            setData(shuffle(x.data));
            result.current = x.data.map(() => undefined);
          } else {
            errorHandler.Writte("Error al capturar el cuestionario", x);
          }
        })
        .catch((x) => {
          errorHandler.Writte("Error al capturar el cuestionario", x);
        });
    }
  });

  useEffect(() => {
    switch (stateTest.current) {
      case "none":
        stateTest.current = "init";
        break;

      case "init":
        stateTest.current = "basic";
        break;

      case "basic":
        stateTest.current = "discriminator";
        break;

      default:
        break;
    }
  }, [data]);

  return (
    <Loading loading={!data.length}>
      <section className="Questions">
        <IonList>
          {data.map((x, i) => (
            <IonRadioGroup
              key={x.id}
              onIonChange={(x) => {
                result.current[index.current + i] = x.detail.value;
              }}
            >
              <IonListHeader>
                <IonLabel>
                  <h1>
                    {index.current + i + 1}.{x.descripcion}
                  </h1>
                </IonLabel>
              </IonListHeader>
              {x.respuestas.map((y, ri) => (
                <IonItem key={y.id} lines="none">
                  <IonRadio value={y.id} name={x.id} />
                  <span className="Number">{["A", "B", "C"][ri]}</span>
                  <IonLabel className="Answer ion-text-wrap">
                    {y.descripcion}
                    {(y.eneatipos || []).join(",")}
                  </IonLabel>
                </IonItem>
              ))}
            </IonRadioGroup>
          ))}
        </IonList>
        <IonButton
          size="large"
          expand="block"
          onClick={() => {
            let newErrors = result.current
              .map((x, i) => {
                if (!x) return `${i + 1}`;
              })
              .filter((x) => x)
              .map((x) => x!);

            if (newErrors.length) {
              newErrors = [
                "Queda(n) por responder a la(s) pregunta(s)",
                newErrors.join(","),
              ];
              setModal(true);
              setErrors(newErrors);
            } else {
              switch (stateTest.current) {
                case "basic":
                  Axios.post(config.api.cuestionario, result.current).then(
                    (x) => {
                      index.current = result.current.length;
                      if (x.status >= 200 && x.status < 400) {
                        setData(shuffle(x.data));
                        x.data.map(() => result.current.push(undefined));
                      } else {
                        errorHandler.Writte(
                          "Error al capturar el cuestionario",
                          x
                        );
                      }
                    }
                  );
                  break;
                case "discriminator":
                  props.onFinish(result.current as string[]);
                  break;
                default:
                  break;
              }
            }
          }}
        >
          Siguiente
        </IonButton>
        <IonModal isOpen={modal && errors.length > 0} backdropDismiss={false}>
          <IonRow>
            <IonCol>
              <IonHeader>
                <IonRow>
                  <IonCol>
                    <h2>Aviso</h2>
                  </IonCol>
                  <IonCol>
                    <IonButton
                      style={{ float: "right" }}
                      onClick={() => setModal(false)}
                      color="danger"
                    >
                      X
                    </IonButton>
                  </IonCol>
                </IonRow>
              </IonHeader>
            </IonCol>
          </IonRow>
          <IonRow className="ion-justify-content-center">
            <IonCol className="ion-text-center">
              <h3>
                {errors.map((x, i) => (
                  <p key={i}>{x}</p>
                ))}
              </h3>
            </IonCol>
          </IonRow>

          <IonRow>
            <IonCol className="ion-text-center">
              <IonButton
                onClick={() => {
                  setModal(false);
                }}
              >
                Cerrar
              </IonButton>

              <p>
                Por favor, revise lo comentarios y vuelva a pulsar sobre{" "}
                <strong>siguiente</strong>
              </p>
            </IonCol>
          </IonRow>
        </IonModal>
      </section>
    </Loading>
  );
};
